export default __webpack_public_path__ + "static/media/clivet_logo.e57ffebc.svg";